import { proxyCustomElement, HTMLElement, h } from '@stencil/core/internal/client';
import { W as WppIcon } from './WppIcon.js';

const wppIconCss = ":host{display:-ms-inline-flexbox;display:inline-flex;color:var(--wpp-prop-icon-color)}";

const WppIconMicBlocked$1 = /*@__PURE__*/ proxyCustomElement(class WppIconMicBlocked extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
    this.__attachShadow();
    this.size = 'm';
    this.width = undefined;
    this.height = undefined;
    this.color = 'var(--wpp-icon-color)';
  }
  render() {
    return (h(WppIcon, { name: "wpp-icon-mic-blocked", width: this.width, height: this.height, size: this.size, color: this.color }, h("path", { d: "M12.9048 5.2381V9.68899C12.4566 9.87588 12.0398 10.123 11.6645 10.4202C11.6816 10.3144 11.6905 10.2058 11.6905 10.0952V5.2381C11.6905 4.12038 10.7844 3.21429 9.66667 3.21429C8.54895 3.21429 7.64286 4.12038 7.64286 5.2381V10.0952C7.64286 11.213 8.54895 12.119 9.66667 12.119C9.89399 12.119 10.1126 12.0816 10.3165 12.0124C10.0912 12.4216 9.91864 12.8639 9.80819 13.3303C9.76127 13.3323 9.71409 13.3333 9.66667 13.3333C7.87832 13.3333 6.42857 11.8836 6.42857 10.0952V5.2381C6.42857 3.44974 7.87832 2 9.66667 2C11.455 2 12.9048 3.44974 12.9048 5.2381ZM9.66667 14.5476C9.66667 15.4349 9.88626 16.2708 10.2741 17.0041L10.2738 17.5833C10.2738 17.9186 10.002 18.1905 9.66667 18.1905C9.35929 18.1905 9.10527 17.9621 9.06507 17.6657L9.05952 17.5833L9.05954 15.7471C6.29357 15.5446 4.09944 13.2832 4.00329 10.4889L4 10.2976V9.89286C4 9.55754 4.27183 9.28571 4.60714 9.28571C4.91452 9.28571 5.16854 9.51412 5.20874 9.81047L5.21429 9.89286V10.2976C5.21429 12.5861 7.02313 14.4522 9.2891 14.5441L9.46429 14.5476H9.66667ZM19.381 14.5476C19.381 17.0066 17.3876 19 14.9286 19C12.4696 19 10.4762 17.0066 10.4762 14.5476C10.4762 12.0886 12.4696 10.0952 14.9286 10.0952C17.3876 10.0952 19.381 12.0886 19.381 14.5476ZM11.6905 14.5476C11.6905 15.2224 11.8969 15.8489 12.25 16.3676L16.7486 11.869C16.2299 11.5159 15.6033 11.3095 14.9286 11.3095C13.1402 11.3095 11.6905 12.7593 11.6905 14.5476ZM14.9286 17.7857C16.7169 17.7857 18.1667 16.336 18.1667 14.5476C18.1667 13.8729 17.9603 13.2463 17.6072 12.7276L13.1086 17.2262C13.6273 17.5793 14.2538 17.7857 14.9286 17.7857Z", fill: "currentColor" })));
  }
  static get registryIs() { return "wpp-icon-mic-blocked-v2-21-0"; }
  static get style() { return wppIconCss; }
}, [1, "wpp-icon-mic-blocked", "wpp-icon-mic-blocked-v2-21-0", {
    "size": [1],
    "width": [2],
    "height": [2],
    "color": [1]
  }]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["wpp-icon-mic-blocked-v2-21-0"];
  components.forEach(tagName => { switch (tagName) {
    case "wpp-icon-mic-blocked-v2-21-0":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, WppIconMicBlocked$1);
      }
      break;
  } });
}

const WppIconMicBlocked = WppIconMicBlocked$1;
const defineCustomElement = defineCustomElement$1;

export { WppIconMicBlocked, defineCustomElement };
